import Home from "../views/home/Home";
import EssentialCousers from "../views/essential/EssentialCousers";
import CourseDetails from "../views/course_details/CourseDetails";
import CertifiedPrime from "../views/certified_prime/CertifiedPrime";
import EnterpriseProgram from "../views/enterprise_program/EnterpriseProgram";
import MasterclassDetails from "../views/course_details/MasterclassDetails";
import DomecqExperiences from "../views/domecq_experiences/DomecqExperiences";
import DomecqAcademy from "../views/domecq_academy/DomecqAcademy";
import FacilitadoresView from "../views/facilitadores/FacilitadoresView";
import LoginView from "../views/auth/LoginView";
import RecoverPassword from "../views/auth/RecoverPassword";
import RegisterView from "../views/auth/RegisterView";
import ContactView from "../views/auth/ContactView";
import FrecuentQuestions from "../views/frecuent_questions/FrecuentQuestions";
import ProfileView from "../views/auth/ProfileView";
import FacilitadorDetail from "../views/facilitadores/FacilitadorDetail";
import UpdateProfile from "../views/auth/UpdateProfile";
import VerifiedAccount from "../views/others/VerifiedAccount";
import ChangePassword from "../views/others/ChangePassword";

const RoutesList = [
   {
      path: "/",
      exact: true,
      component: Home,
      pathName: "Inicio",
   },
   {
      path: "/cursos_esenciales",
      exact: true,
      component: EssentialCousers,
      pathName: "cursos esenciales",
   },
   {
      path: "/cursos_esenciales/:id",
      exact: true,
      component: CourseDetails,
      pathName: "cursos esenciales",
   },
   {
      path: "/certificado_prime",
      exact: true,
      component: CertifiedPrime,
      pathName: "certificado prime",
   },
   {
      path: "/certificado_prime/:id",
      exact: true,
      component: CourseDetails,
      pathName: "cursos esenciales",
   },
   {
      path: "/masterclass/:id",
      exact: true,
      component: MasterclassDetails,
      pathName: "masterclass",
   },
   {
      path: "/programa_enterprise",
      exact: true,
      component: EnterpriseProgram,
      pathName: "Programa Enterprise",
   },
   {
      path: "/programa_emblem",
      exact: true,
      component: DomecqExperiences,
      pathName: "Programa Enterprise",
   },
   {
      path: "/domecq_academy",
      exact: true,
      component: DomecqAcademy,
      pathName: "Programa Academy",
   },
   {
      path: "/programa_emblem",
      exact: true,
      component: DomecqExperiences,
      pathName: "Programa Enterprise",
   },
   {
      path: "/facilitadores",
      exact: true,
      component: FacilitadoresView,
      pathName: "Facilitadores",
   },
   {
      path: "/facilitador/:id",
      exact: true,
      component: FacilitadorDetail,
      pathName: "Facilitador",
   },
   //  auth
   {
      path: "/iniciar_sesion",
      exact: true,
      component: LoginView,
      pathName: "iniciar sesión",
   },
   {
      path: "/recuperar_contraseña",
      exact: true,
      component: RecoverPassword,
      pathName: "iniciar sesión",
   },
   {
      path: "/registro",
      exact: true,
      component: RegisterView,
      pathName: "iniciar sesión",
   },
   {
      path: "/contacto",
      exact: true,
      component: ContactView,
      pathName: "iniciar sesión",
   },
   {
      path: "/preguntas_frecuentes",
      exact: true,
      component: FrecuentQuestions,
      pathName: "Preguntas frecuentes",
   },
   {
      path: "/perfil",
      exact: true,
      component: ProfileView,
      pathName: "Perfil",
   },
   {
      path: "/editar_perfil",
      exact: true,
      component: UpdateProfile,
      pathName: "Editar Perfil",
   },
   {
      path: "/s",
      exact: true, 
      component: VerifiedAccount,
      pathName: "Cuenta verificada",
   },
   {
      path: "/recover",
      exact: true,
      component: ChangePassword,
      pathName: "Cuenta verificada",
   },
];

export default RoutesList;
